import { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { PageContext } from '@contexts/page-context'
import { gnarSpec } from '@lib/tracking/gnar'
import { ButtonCta } from '@ui-lib/button'
import { ExternalLink } from '@ui-lib/link'

import styles from './workweek-with-ai.module.scss'
import { useBannerShow } from '@lib/hooks'
import cn from 'classnames'

const BANNER_URL =
  'https://go.grammarly.com/2025-the-productivity-shift?utm_source=website&utm_medium=banner&utm_campaign=G4B-2025-SOBC-Productivity-Shift'
const BANNER_ID = 'SOBC_workweek_with_ai'

export const WorkweekWithAiBanner = ({ lightTheme = true }: { lightTheme: boolean }) => {
  const { pageId, slug } = useContext(PageContext)

  useBannerShow(true, BANNER_ID, BANNER_URL)

  return (
    <aside className={cn(styles.banner, lightTheme && styles.bannerLight)}>
      <ExternalLink
        className={styles.bannerLink}
        target="_blank"
        href={BANNER_URL}
        onClick={() => {
          gnarSpec.bannerClick(BANNER_ID, pageId, slug, BANNER_URL)
        }}
      >
        <span>
          <FormattedMessage
            id="banner.workweekWithAi.copy"
            description="Banner - Workweek With AI - Copy"
            defaultMessage="<strong>New Data:</strong> How to reclaim the workweek with AI"
            values={{
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </span>
        <ButtonCta
          className={styles.bannerButton}
          text={
            <FormattedMessage
              id="banner.workweekWithAi.link"
              description="Banner - Workweek With AI - CTA Text"
              defaultMessage="Read the Report"
            />
          }
          showArrow
          padding="compact"
        />
      </ExternalLink>
    </aside>
  )
}
